<div class="qo-flex-row-top-left word-break">
	<div>{{currentText}}</div>
	<a [class.hidden]="hideToggle" class="read-more-less-a"
	   (click)="toggleView()">{{isCollapsed ? ('PUNCH_CLOCK.READ_MORE' | translate) : 'PUNCH_CLOCK.READ_LESS' | translate}}</a>
</div>
